import { render, staticRenderFns } from "./NewsFinderAndCreator.vue?vue&type=template&id=0e519d40&"
import script from "./NewsFinderAndCreator.vue?vue&type=script&lang=js&"
export * from "./NewsFinderAndCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports